import { PropsWithChildren } from 'react';

import * as css from './PlaybackLayout.css';

export const PlaybackLayout = ({ children }: PropsWithChildren) => {
    return <div className={css.layoutRoot}>{children}</div>;
};

export const PlaybackLayoutHeader = ({ children }: PropsWithChildren) => {
    return <div className={css.layoutHeaderItem}>{children}</div>;
};

export const PlaybackLayoutBody = ({ children }: PropsWithChildren) => {
    return <div className={css.layoutBodyItem}>{children}</div>;
};

export const PlaybackLayoutFooter = ({ children }: PropsWithChildren) => {
    return <div className={css.layoutFooterItem}>{children}</div>;
};
